export default __webpack_public_path__ + "static/media/p13.118e1fc9.jpeg";